module.exports = __webpack_public_path__ + "static/media/whaten.84086c1b.svg";